package top.wcpe.allincore.dsl.compiler.pipeline

import top.wcpe.allincore.dsl.compiler.ast.ScreenKind
import top.wcpe.allincore.dsl.compiler.diag.Diagnostic
import top.wcpe.allincore.dsl.ir.model.UiIr

/**
 * 编译结果：成功携带 [UiIr]，失败仅携带诊断。
 *
 * 不论成功失败，[diagnostics] 均为流水线全过程收集到的诊断快照。
 */
sealed interface CompileResult {

    val diagnostics: List<Diagnostic>

    /**
     * 编译成功：codegen 已产出 [UiIr]；可能仍带有 WARNING 级别诊断。
     *
     * Stage 11：[kind] 标识源码顶层是 `screen` 还是 `hud`，便于服务端把产物分别送入
     * ScreenRegistry / HudRegistry。当源码不是 screen / hud（例如 component / theme）时为 null。
     *
     * 精细化热重载：[usedComponents] 为本 screen 实际展开用到的组件名集合（已含传递依赖，
     * 因组件展开是递归的，A 用 B 时 B 也会被记录）；[usedTheme] 为本 screen 声明的主题 scheme 名
     * （`theme { scheme = "X" }`），未声明主题则为 null。服务端据此建反向依赖索引：改某组件/主题文件时
     * 只重编引用它的 screen，而非全量。
     */
    data class Success(
        val ir: UiIr,
        override val diagnostics: List<Diagnostic>,
        val kind: ScreenKind? = null,
        val usedComponents: Set<String> = emptySet(),
        val usedTheme: String? = null,
    ) : CompileResult

    /** 编译失败：流水线在 lex/parse/semantic 任一环节中断；[diagnostics] 至少含一条 ERROR。 */
    data class Failure(
        override val diagnostics: List<Diagnostic>,
    ) : CompileResult
}
